import { observer } from 'mobx-react-lite'
import { LoginShadcnComponent } from 'app/components/login/LoginShadcnComponent'
import { useLogin } from 'app/components/login/useLogin'

export default observer(function LoginPage(): React.ReactElement {
  const loginProps = useLogin()

  return <LoginShadcnComponent {...loginProps} />
})
